import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import styles from './BlogTeaser.module.css';

const POSTS = [
  { id: 'what-is-3d-printing',     titleKey: 'blog.posts.whatIs3DPrinting.title', excerptKey: 'blog.posts.whatIs3DPrinting.excerpt', categoryKey: 'blog.categories.guide',           readTime: '8' },
  { id: 'best-filament-types',     titleKey: 'blog.posts.filamentTypes.title',    excerptKey: 'blog.posts.filamentTypes.excerpt',    categoryKey: 'blog.categories.material',        readTime: '6' },
  { id: 'how-to-prepare-3d-model', titleKey: 'blog.posts.prepareModel.title',     excerptKey: 'blog.posts.prepareModel.excerpt',     categoryKey: 'blog.categories.guide',           readTime: '10' },
  { id: 'fdm-vs-sla',              titleKey: 'blog.posts.fdmVsSla.title',         excerptKey: 'blog.posts.fdmVsSla.excerpt',         categoryKey: 'blog.categories.comparison',      readTime: '7' },
  { id: 'selling-3d-prints',       titleKey: 'blog.posts.sellingPrints.title',    excerptKey: 'blog.posts.sellingPrints.excerpt',    categoryKey: 'blog.categories.business',        readTime: '9' },
  { id: 'troubleshooting-prints',  titleKey: 'blog.posts.troubleshooting.title',  excerptKey: 'blog.posts.troubleshooting.excerpt',  categoryKey: 'blog.categories.troubleshooting', readTime: '11' },
];

const BlogTeaser = () => {
  const { t } = useLanguage();
  const post = useMemo(() => POSTS[Math.floor(Math.random() * POSTS.length)], []);

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.heading}>{t('home.blogTeaser.heading')}</h2>
          <Link to="/blog" className={styles.viewAll}>
            {t('home.blogTeaser.viewAll')} →
          </Link>
        </div>

        <article className={styles.card}>
          <div className={styles.imageWrap}>
            <img src="/images/aboutus.png" alt={t(post.titleKey)} loading="lazy" />
            <span className={styles.category}>{t(post.categoryKey)}</span>
          </div>

          <div className={styles.body}>
            <div className={styles.meta}>
              <span>{post.readTime} {t('blog.reading')}</span>
            </div>
            <h3 className={styles.title}>{t(post.titleKey)}</h3>
            <p className={styles.excerpt}>{t(post.excerptKey)}</p>

            <div className={styles.actions}>
              <Link to={`/blog/${post.id}`} className={styles.primaryBtn}>
                {t('home.blogTeaser.readMore')}
              </Link>
              <Link to="/blog" className={styles.secondaryBtn}>
                {t('home.blogTeaser.exploreAll')}
              </Link>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
};

export default BlogTeaser;
